import { FC } from "react";
import { useParams } from "react-router-dom";

import { OpsReportDisplay } from "@components/OpsReportDisplay";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { withPermissions } from "@components/withPermissions";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useOpsReportInstance } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

interface ReportPageProps {
  device?: FieldDevice;
}

const OpsReportPageBase: FC<ReportPageProps> = ({ device }) => {
  const { name } = useParams<{ name: string }>();

  const instanceQuery = useOpsReportInstance(
    name,
    device && { FieldDeviceId: device.id }
  );

  return (
    <QueryStateIndicator {...instanceQuery}>
      {instance => <OpsReportDisplay embedConfig={instance} />}
    </QueryStateIndicator>
  );
};

export const OpsReportPage = withPermissions(
  OpsReportPageBase,
  [Permissions.OpsReportRead, Permissions.OpsConsolePreRelease],
  "and"
);
